import { render } from "./AppSkeletonMedia.vue?vue&type=template&id=670c83d7&scoped=true&ts=true"
import script from "./AppSkeletonMedia.vue?vue&type=script&lang=ts"
export * from "./AppSkeletonMedia.vue?vue&type=script&lang=ts"

import "./AppSkeletonMedia.vue?vue&type=style&index=0&id=670c83d7&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670c83d7"]])

export default __exports__